import React, { memo, useId } from 'react'

import { timesGenerator } from '@/legacy-src/utilities/helpers'

import { Checkbox } from '@/src/domains/design-system/components/Checkbox'
import { Label } from '@/src/domains/design-system/components/Label'

type Props = {
  selectTime: (time: string) => void
  times: string[]
}

const generatedTimes = timesGenerator()

const TimesCheckbox = ({ selectTime, times }: Props) => {
  const id = useId()
  return generatedTimes.map((time: string) => {
    const text = time
    const value = time.replace(/:00/g, '').replace(/\s+/g, '')
    return (
      <div className="flex items-center gap-3" key={time}>
        <Checkbox id={`${id}-${time}`} checked={times?.includes(value)} onCheckedChange={() => selectTime(value)} />
        <Label variant="selection-control" className="grow" htmlFor={`${id}-${time}`}>
          {text}
        </Label>
      </div>
    )
  })
}

export default memo<Props>(TimesCheckbox)
